/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {ClientInfo} from '../models/ClientInfo';
import type {Error} from '../models/Error';

export interface LogClientInfo$Request {
    clientInfo: ClientInfo;
}

export interface LogClientInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const logClientInfoRequest = createAction<PayloadData<void, LogClientInfo$Request>>('CLIENT_INFO__LOG_CLIENT_INFO__REQUEST');
export const logClientInfoSuccess = createAction<PayloadData<void, LogClientInfo$Request>>('CLIENT_INFO__LOG_CLIENT_INFO__SUCCESS');
export const logClientInfoFailure = createAction<PayloadData<Error, LogClientInfo$Request, true>>('CLIENT_INFO__LOG_CLIENT_INFO__FAILURE');

export const logClientInfoActions = [
    logClientInfoRequest,
    logClientInfoSuccess,
    logClientInfoFailure
] as const;

/**
 * @param {ClientInfo} meta.clientInfo
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const logClientInfo = (meta: LogClientInfo$Request, config?: LogClientInfo$Config) => {
    return {
        CALL_API: {
            types: logClientInfoActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/client-info`,
            TRANSPORT_REQUEST_BODY: meta.clientInfo,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

